import './App.css';
import { Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import NotFoundPage from './pages/404';
import Game from './game/game';
import BugBustOverlay from './debugger/bugBustOverlay';
import { GameProvider } from './data/gameContext';
import BugPanelOverlay from './debugger/bugPanelOverlay';
import ZxSpectrum from './pages/HomePage/zxSpectrum';
import HighScores from './pages/HighScores';

export default function App() {
  return (
    <GameProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/game" element={<Game />} />
          <Route path="/TheWildBunch" element={<ZxSpectrum />} />
          <Route path="/high-scores" element={<HighScores />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <BugPanelOverlay/>
        <BugBustOverlay/>
      </div>
    </GameProvider>
  );
}


